module.exports = require("./angular-flot.js");


//////////////////
// WEBPACK FOOTER
// angular-flot (bower component)
// module id = 578
// module chunks = 0